import { ColumnDef } from '@tanstack/react-table';
import React from 'react';

import { UserWithHotel } from '../../../../queries/usersQuery';
import { formatFirestoreDate } from '../../../../utils/formatFirestoreDate';
import { ActionRow } from './Rows/ActionRow';
import { HotelNamesRow } from './Rows/HotelNamesRow';
import { IsHotelspotAdminRow } from './Rows/IsHotelspotAdminRow';
import { IsStaffRow } from './Rows/IsStaffRow';

export const UsersColumns: ColumnDef<UserWithHotel>[] = [
  {
    accessorKey: 'name',
    header: 'Name',
    cell: ({ row }) => {
      const { name, surname, displayName } = row.original;
      return [name, surname].filter(Boolean).join(' ') || displayName || '-';
    },
  },
  {
    accessorKey: 'email',
    header: 'E-mail',
  },
  {
    accessorKey: 'phoneNumber',
    header: 'Phone Number',
    cell: ({ row }) => {
      const { phoneNumber } = row.original;
      return phoneNumber || '-';
    },
  },
  {
    accessorKey: 'organizations',
    header: 'Assigned access',
    // Wąska kolumna + nazwy jedna pod drugą, żeby reszta kolumn mieściła się na ekranie.
    meta: { width: 'w-[160px] max-w-[160px]' },
    cell: ({ row }) => <HotelNamesRow names={row.original.organizations} />,
    enableSorting: false,
  },
  {
    accessorKey: 'ownerHotels',
    header: 'Owner',
    meta: { width: 'w-[160px] max-w-[160px]' },
    cell: ({ row }) => <HotelNamesRow names={row.original.ownerHotels} />,
    enableSorting: false,
  },
  {
    accessorKey: 'isStaff',
    header: 'Staff',
    cell: ({ row }) => <IsStaffRow data={row.original} />,
    enableSorting: false,
  },
  {
    accessorKey: 'isHotelspotAdmin',
    header: 'Admin',
    cell: ({ row }) => <IsHotelspotAdminRow data={row.original} />,
    enableSorting: false,
  },
  {
    accessorKey: 'lastLoginAt',
    header: 'Last login',
    cell: ({ row }) => {
      const { lastLoginAt } = row.original;
      if (!lastLoginAt) return <span className="text-gray-400">—</span>;
      // Data + godzina — przy ostatnim logowaniu sama data mówi za mało.
      return new Date(lastLoginAt).toLocaleString('en-GB', {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
      });
    },
  },
  {
    accessorKey: 'createdAt',
    header: 'Created At',
    cell: ({ row }) => {
      const date = row.original.createdAt;
      return formatFirestoreDate(date, {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
      }, 'en-GB', '-');
    },
  },
  {
    id: 'action',
    header: '',
    cell: ({ row }) => <ActionRow data={row.original} />,
  },
];
